import {AlertColorConfig} from '@esgi/ui/alert';

export const alertColorConfig: AlertColorConfig = {
	borderColor: 'mild',
	headerBgColor: 'background',
	headerTextColor: 'primary',
};
